import React, { useState } from 'react';
import { CUSTOMER_LOGOS, CUSTOMER_LOGOS_HEADER } from '../../content/customerLogos';
import './HomeLogoRow.css';

/**
 * HomeLogoRow — "Used by people who work at" (was "People use CellCog at") (Nitish, Sep 25 2026; list + rulings: Aria, Org Drive
 * Marketing/Customer Logos/people_use_cellcog_at_list_sep25.md). ONE component on the homepage and
 * /ai-employees, right under the demo frame; the list lives in content/customerLogos.js so a removal is
 * one line.
 *
 * All logos in their own colours (his ruling), two slow counter-drifting rows (~34 px/s, Spinnable-paced),
 * hover pauses, a visible Pause button (WCAG 2.2.2), prefers-reduced-motion = one static wrapped set.
 * Each logo ships a light-face and a dark-face file; CSS shows the one for html[data-mkt-theme].
 * The accessible name sits on the item (role="img"), so hiding either file never hides the name.
 */
const BASE = '/assets/customer-logos/';

export default function HomeLogoRow() {
  const [paused, setPaused] = useState(false);
  const half = Math.ceil(CUSTOMER_LOGOS.length / 2);
  const rows = [CUSTOMER_LOGOS.slice(0, half), CUSTOMER_LOGOS.slice(half)];

  const renderSet = (row, copy) => (
    <div className="home-lr__set" aria-hidden={copy === 1 ? 'true' : undefined}>
      {row.map((l) => (
        <span
          className="home-lr__item"
          key={`${l.slug}-${copy}`}
          role={copy === 0 ? 'img' : undefined}
          aria-label={copy === 0 ? l.name : undefined}
          style={{ '--w': `${l.w}px`, '--h': `${l.h}px` }}
        >
          <img className="home-lr__img home-lr__img--l" src={`${BASE}${l.slug}.webp`} alt="" width={l.w} height={l.h} loading="lazy" decoding="async" />
          <img className="home-lr__img home-lr__img--d" src={`${BASE}${l.slug}-dark.webp`} alt="" width={l.w} height={l.h} loading="lazy" decoding="async" />
        </span>
      ))}
    </div>
  );

  return (
    <section className={`home-lr ${paused ? 'is-paused' : ''}`} aria-label={CUSTOMER_LOGOS_HEADER}>
      <div className="home-lr__head">
        <span className="home-lr__lab">{CUSTOMER_LOGOS_HEADER}</span>
        <button
          type="button"
          className="home-lr__pause"
          onClick={() => setPaused((p) => !p)}
          aria-pressed={paused}
          aria-label={paused ? 'Play the logo scroll' : 'Pause the logo scroll'}
          data-track="logo_row_pause"
        >
          {paused ? (
            <svg viewBox="0 0 10 10" width="9" height="9" aria-hidden="true"><path d="M2.5 1.5 8.5 5 2.5 8.5z" fill="currentColor" /></svg>
          ) : (
            <svg viewBox="0 0 10 10" width="9" height="9" aria-hidden="true"><rect x="2" y="1.5" width="2" height="7" rx=".6" fill="currentColor" /><rect x="6" y="1.5" width="2" height="7" rx=".6" fill="currentColor" /></svg>
          )}
        </button>
      </div>
      {rows.map((row, i) => (
        <div className="home-lr__marquee" key={i}>
          <div className={`home-lr__track ${i === 1 ? 'home-lr__track--rev' : ''}`}>
            {renderSet(row, 0)}
            {renderSet(row, 1)}
          </div>
        </div>
      ))}
    </section>
  );
}
